export const rootElementId = 'welcome-devex';

export const translationConfig = {
  common: [],
  feature: 'Feature.CashOut'
};
